module.exports = __webpack_public_path__ + "img/relampago.8436891f.png";